import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import DayPicker from 'react-day-picker';
import NumericInput from 'react-numeric-input';
import { terminalTypeData } from './constants';
import 'react-day-picker/lib/style.css';

const DateTimeCard = React.memo(function DateTimeCard({
  state,
  onChange,
  onAirlineReturnChange,
  onFlightHourReturnChange,
  onFlightMinuteReturnChange,
  onPickupDateTimeReturnChange,
  onRecurringEndDateChange,
  onDayClick,
  onPaxCountReturnChange,
  errors,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-violet" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-violet"><i className="fas fa-calendar-alt" /></span>
        <span className="rx-card-title">Date &amp; Time</span>
      </div>
      <div className="rx-card-body">
        {state.tripTypeId === '2' && (
          <div className="rx-sub-card">
            <div className="rx-sub-card-hd">Return Details</div>
            <div className="rx-sub-card-body">
              <div className="rx-cols-4">
                <div className="rx-fg">
                  <label>Airline</label>
                  <SelectBox dataSource={state.dropdownAirline} placeholder="Select airline" name="airlineIdReturn" defaultValue={0} value={state.airlineIdReturn} displayExpr="airLineName" valueExpr="airLineId" onSelectionChanged={onAirlineReturnChange} showClearButton={true} searchEnabled={true} />
                </div>
                <div className="rx-fg">
                  <label>Flight #</label>
                  <input type="text" className="rx-ff" maxLength={25} value={state.flightNumberReturn} onChange={onChange} name="flightNumberReturn" placeholder="Flight #" />
                  {errors.flightNumberReturn.length > 0 && <span className="rx-err">{errors.flightNumberReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Terminal Type</label>
                  <select className="rx-ff" name="terminalTypeReturn" value={state.terminalTypeReturn} onChange={onChange}>
                    <option value="0">Select terminal type</option>
                    {terminalTypeData.map((item, i) => (<option key={i} value={item.id}>{item.name}</option>))}
                  </select>
                </div>
                <div className="rx-fg">
                  <label>Terminal</label>
                  <input type="text" className="rx-ff" maxLength={25} value={state.terminalReturn} onChange={onChange} name="terminalReturn" placeholder="Terminal" />
                </div>
              </div>
              <div className="rx-cols-3">
                <div className="rx-fg">
                  <label>Pax # <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="noOfPaxReturn" value={state.noOfPaxReturn} min={1} max={100} onChange={(value) => onPaxCountReturnChange(value)} />
                  {errors.noOfPaxReturn.length > 0 && <span className="rx-err">{errors.noOfPaxReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Flight Time [hh]</label>
                  <SelectBox dataSource={state.dropdownHours} placeholder="Select Hour" name="id" defaultValue={0} value={state.flightHourReturn} displayExpr="name" valueExpr="id" onSelectionChanged={onFlightHourReturnChange} showClearButton={true} searchEnabled={true} />
                  {errors.flightTimeReturn.length > 0 && <span className="rx-err">{errors.flightTimeReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>[min]</label>
                  <SelectBox dataSource={state.dropdownMinutes} placeholder="Select Minute" name="id" defaultValue={0} value={state.flightMinuteReturn} displayExpr="name" valueExpr="id" onSelectionChanged={onFlightMinuteReturnChange} showClearButton={true} searchEnabled={true} />
                </div>
              </div>
              <div className="rx-fg">
                <label>Pick-up Date &amp; Time <span className="req">*</span></label>
                <DateBox type="datetime" name="puDateTimeReturn" placeholder="MM/dd/yyyy HH:mm" displayFormat="MM/dd/yyyy HH:mm" showAnalogClock={true} useMaskBehavior={true} defaultValue={state.puDateTimeReturn} value={state.puDateTimeReturn} onValueChanged={onPickupDateTimeReturnChange} width="100%" acceptCustomValue={false} min={state.puDateTime} />
                {errors.puDateTimeReturn && errors.puDateTimeReturn.length > 0 && <span className="rx-err">{errors.puDateTimeReturn}</span>}
              </div>
            </div>
          </div>
        )}
        {state.tripTypeId === '3' && (
          <div className="rx-sub-card">
            <div className="rx-sub-card-hd">Recurring Details</div>
            <div className="rx-sub-card-body">
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Repeat Type <span className="req">*</span></label>
                  <select className="rx-ff" name="recurringTypeId" value={state.recurringTypeId} onChange={onChange}>
                    <option value="1">Daily</option>
                    <option value="2">Weekly</option>
                    <option value="3">Monthly</option>
                  </select>
                </div>
                <div className="rx-fg">
                  <label>End Date <span className="req">*</span></label>
                  <DateBox type="date" name="recurringEndDate" placeholder="mm/dd/yyyy" useMaskBehavior={true} defaultValue={state.recurringEndDate} value={state.recurringEndDate} onValueChanged={onRecurringEndDateChange} width="100%" acceptCustomValue={false} min={state.puDateTime} />
                  {errors.recurringEndDate.length > 0 && <span className="rx-err">{errors.recurringEndDate}</span>}
                </div>
              </div>
              {state.recurringTypeId == 1 && (
                <div className="rx-fg">
                  <DayPicker selectedDays={state.selectedDays} onDayClick={onDayClick} />
                </div>
              )}
              {(state.recurringTypeId == 2 || state.recurringTypeId == 3) && (
                <div className="rx-day-checks">
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => {
                    const key = state.recurringTypeId == 2 ? `isWeek${day}` : `isMonth${day}`;
                    return (
                      <label key={day} className="rx-day-chk">
                        <input type="checkbox" checked={state[key]} onChange={onChange} name={key} />
                        {day.toUpperCase()}
                      </label>
                    );
                  })}
                </div>
              )}
              {errors.recurring.length > 0 && <span className="rx-err">{errors.recurring}</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default DateTimeCard;
